import classNames from 'classnames';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

const NewTileInner = ({ date, isHero, name, thumbnail, description, price, genre, type, venue, url, isActive = true }) => {
    // Visible link in the heading which can be tab focused
    const renderHeadingLink = () => {
        return (
            <Link className="card-link" to={url} tabIndex={isActive ? undefined : -1}>{name}</Link>
        );
    };

    // invisible link which must be a direct child of .tile element to cover the whole card
    // cannot be tab focused, we use the heading link for that instead
    const renderClickableLink = () => {
        return (
            <Link className="card-link-clickable" to={url} tabIndex={-1} aria-hidden="true">{name}</Link>
        );
    };

    const renderShowContent = () => (
        <div className="show-content">
            {date && <p className="date">{date}</p>}
            <h3 className="h5 title">{renderHeadingLink()}</h3>
            {price && <p className="price">{price}</p>}
            {venue && <p className="location">{venue}</p>}
            {genre && <p className="genre">{genre}</p>}
        </div>
    );

    const renderPageContent = () => (
        <div className="page-content">
            <h3 className="h4 title">{renderHeadingLink()}</h3>
            {description && <p className="description">{description}</p>}
        </div>
    );

    const renderVenueContent = () => (
        <div className="venue-content">
            <h3 className="h6 title">{renderHeadingLink()}</h3>
            {description && <p className="description">{description}</p>}
        </div>
    );

    const renderNewsContent = () => (
        <div className="news-content">
            {/* TODO: Implement date with publish time feature */}
            {/* <p className="date">{date}</p> */}
            {isHero ? <h3 className="h3 title">{renderHeadingLink()}</h3> : <h3 className="h5 title">{renderHeadingLink()}</h3>}
            <p className="description">{description}</p>
            {isHero && <button aria-hidden="true" tabIndex={-1} className="button secondary">Learn more</button>}
        </div>
    );

    const thumbnailClass = classNames('thumbnail-wrapper', {
        'is-news': type === 'news'
    });

    return (
        <React.Fragment>
            {/* invisible link which must be a direct child of .tile element to cover the whole card */}
            {renderClickableLink()}
            <div className="content-wrapper">
                {type === 'show' && renderShowContent()}
                {type === 'page' && renderPageContent()}
                {type === 'venue' && renderVenueContent()}
                {type === 'news' && renderNewsContent()}
            </div>
            <div className={thumbnailClass}>
                {type === 'news' && !isHero && <button className="button secondary" aria-hidden="true" tabIndex={-1}>Learn more</button>}
                <img className="thumbnail desktop" src={thumbnail.landscape} alt={name} />
                <img className="thumbnail mobile" src={thumbnail.square} alt={name} />
            </div>
        </React.Fragment>
    );
};

NewTileInner.propTypes = {
    date: PropTypes.string,
    description: PropTypes.string,
    isHero: PropTypes.bool,
    name:  PropTypes.string.isRequired,
    thumbnail:  PropTypes.object.isRequired,
    price: PropTypes.string,
    genre: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string,
    venue: PropTypes.string,
    // whether the tile is currently in view
    isActive: PropTypes.bool,
};

NewTileInner.defaultProps = {
    isHero: false,
    isActive: true,
};

export default NewTileInner;
